const books = {
  chemistry: [
    {
      title: " The Periodic Table",
      url: "pdf/chemistry/Periodic-Table-Downloadable-Version.pdf",
      author: "Alison De Best",
    },
    {
      title: "Best Chemistry self learning  Book",
      url: "pdf/chemistry/Chemistry.pdf",
      author: "Tracy Poulsen",
    },
    {
      title:
        " National Science Education Standards Models for Meaningful Learning in the High School Chemistry Classroom",
      url: "pdf/chemistry/highSchoolChemistry.pdf",
      author: "Stacey Bretz",
    },
    {
      title: "The Golden Book of Chemistry Experiments (Robert Brent)",
      url: "pdf/chemistry/RobertBrent.pdf",
      author: "Robert Brent",
    },
    {
      url: "pdf/chemistry/basicChemistry.pdf",
      title: "The Basics of Chemistry",
      author: "Richard L. Myers",
    },
    {
      title: "South Sudan Secondary Chemistry S1  ",
      url: "pdf/chemistry/chemistry_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Chemistry S1 Teacher's Guide",
      url: "pdf/chemistry/chemistryteacherguide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Chemistry S2  ",
      url: "pdf/chemistry/chemistry_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Chemistry S2 Teacher's Guide",
      url: "pdf/chemistry/chemistryteacherguide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Chemistry S3  ",
      url: "pdf/chemistry/chemistry_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Chemistry S3 Teacher's Guide",
      url: "pdf/chemistry/chemistryteacherguide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Chemistry S4  ",
      url: "pdf/chemistry/chemistry_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Chemistry S4 Teacher's Guide",
      url: "pdf/chemistry/chemistryteacherguide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  physics: [
    {
      title:"Cambridge IGCSE® Physics (0625) Past paper questions and answers",
      url:"pdf/physics/Cambridge IGCSE Physics (0625) Past paper questions and answers.pdf",
      author: "Cambridge IGCSE Physics",

    },
    {
      title:"College Physics",
      url:"pdf/physics/College_Physics-WEB_2s5sHvR.pdf",
      author: "OpenStax",

    },
    {
      title:"High School Physics best physics book for High School",
      url:"pdf/physics/Physics-WEB_Sab7RrQ.pdf",
      author: "OpenStak",

    },
    {
      title: "South Sudan Secondary Physics S1  ",
      url: "pdf/physics/physics_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Physics S1 Teacher's Guide",
      url: "pdf/physics/physicsteacherguide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Physics S2  ",
      url: "pdf/physics/physics_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Physics S2 Teacher's Guide",
      url: "pdf/physics/physicsteacherguide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Physics S3  ",
      url: "pdf/physics/physics_s3_compressed.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Physics S3 Teacher's Guide",
      url: "pdf/physics/physicsteacherguide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Physics S4  ",
      url: "pdf/physics/physics_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Physics S4 Teacher's Guide",
      url: "pdf/physics/physicsteacherguide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  mathematics: [
    {
      title: "Complete Pure Mathematics for Cambridge International as A level",
      url: "pdf/mathematics/Complete Pure Mathematics 2 & 3 for Cambridge International AS & A Level ( PDFDrive ).pdf",
      author: "James Nicholson ",
    },
    {
      title: "Cambridge IGCSE Mathematics Core and Extended Third Edition",
      url: "pdf/mathematics/Cambridge IGCSE Mathematics Core & Extended.pdf",
      author: "Terry Wall ",
    },
    {
      title: "Complete International Mathematics for Cambridge IGCSE (0607)",
      url: "pdf/mathematics/Complete International Mathematics for Cambridge IGCSE ( PDFDrive ).pdf",
      author: "Terry Wall ",
    },
    {
      title: "190 ready-to-use activities that make math fun!",
      url: "pdf/mathematics/mathsfun.pdf",
      author: "George Watson & Alan Anthony",
    },
    {
      title: "190 ready-to-use activities that make math fun!",
      url: "pdf/mathematics/mathsfun.pdf",
      author: "George Watson & Alan Anthony",
    },
    {
      title: "South Sudan Secondary Mathematics S1  ",
      url: "pdf/mathematics/mathematics_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Mathematics S1 Teacher's Guide",
      url: "pdf/mathematics/mathematicsteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Mathematics S2  ",
      url: "pdf/mathematics/mathematics_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Mathematics S2 Teacher's Guide",
      url: "pdf/mathematics/mathematicsteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Mathematics S3  ",
      url: "pdf/mathematics/mathematics_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Mathematics S3 Teacher's Guide",
      url: "pdf/mathematics/mathematicsteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Mathematics S4  ",
      url: "pdf/mathematics/mathematics_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Mathematics S4 Teacher's Guide",
      url: "pdf/mathematics/mathematicsteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  // BIOLOGY
  biology: [
    {
      title:
        "Cambridge IGCSE Biology Third Edition ",
      url: "pdf/biology/Cambridge-IGCSE-Biology-3rd-Edition-.pdf",
      author: "Dave Hayward",
    },
    {
      title:
        "BIOLOGY HIGH SCHOOL ASSESSMENT STUDENT RESOURCE BOOK High School Biology ",
      url: "pdf/biology/biologyAssesement.pdf",
      author: "Prince George",
    },
    {
      title: "South Sudan Secondary Biology S1  ",
      url: "pdf/biology/biology_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Biology S1 Teacher's Guide",
      url: "pdf/biology/biologyteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Biology S2  ",
      url: "pdf/biology/biology_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Biology S2 Teacher's Guide",
      url: "pdf/biology/biologyteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Biology S3  ",
      url: "pdf/biology/biology_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Biology S3 Teacher's Guide",
      url: "pdf/biology/biologyteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Biology S4  ",
      url: "pdf/biology/biology_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Biology S4 Teacher's Guide",
      url: "pdf/biology/biologyteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  // CRE
  cre: [
    {
      title:
        "Bible Stories From The Old Testament_ Stories that uplift, educate, and inspire (Judeo-Christian Ethics Series) (Judeo-Christian Ethics Series) ( PDFDrive ) ",
      url: "pdf/cre/Old_Testament_Stories.pdf",
      author: "Katherine L. Whaley",
    },
    {
      title:
        "Bible Prophecy pdf - End Time Bible Prophecy, Bible Prophecies ( PDFDrive )",
      url: "pdf/cre/BibleProphecy.pdf",
      author: "Napoleon Hill",
    },
    {
      title:
        "The Bible Story Handbook_ A Resource for Teaching 175 Stories From the Bible ( PDFDrive )",
      url: "pdf/cre/TheBibleStoryHandbook.pdf",
      author: "John H. Walton, Kim E. Walton",
    },

    {
      title: "South Sudan Secondary C.R.E S1  ",
      url: "pdf/cre/cre_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary C.R.E S1 Teacher's Guide",
      url: "pdf/cre/creteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary C.R.E S2  ",
      url: "pdf/cre/cre_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary C.R.E S2 Teacher's Guide",
      url: "pdf/cre/creteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary C.R.E S3  ",
      url: "pdf/cre/cre_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary C.R.E S3 Teacher's Guide",
      url: "pdf/cre/creteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary C.R.E S4  ",
      url: "pdf/cre/cre_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary C.R.E S4 Teacher's Guide",
      url: "pdf/cre/creteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  literature: [
    {
      title:
        "THE HISTORY NAPOLEON BONAPARTE EMPEROR OF THE FRENCH, KING OF ITALY",
      author: "",
      url: "/pdf/literature/frenchEmpire.pdf",
    },
    {
      title: "Napoleon Bonaparte and the Legacy of the French Revolution",
      author: "",
      url: "/pdf/literature/napoleo_biography.pdf",
    },
    {
      title: "Chinua Achebe’s Things Fall Apart",
      author: "Chinua Achebe",
      url: "/pdf/literature/ChinuaAchebe.pdf",
    },
    {
      title: "The French Revolution, 1789-1799",
      author: "Peter McPhee",
      url: "/pdf/literature/french_revolution.pdf",
    },
  ],
  english: [
    {
      title: "Spoken English: Flourish Your Language",
      author: "Robert Carmen",
      url: "/pdf/english/flourish_your_english.pdf",
    },
    {
      title:
        "Webster's Word Power Better English Grammar. Improve Your Written and Spoken English",
      url: "/pdf/english/better_english_grammar.pdf",
      author: "G&G Webster’s ",
    },
    {
      title:
        "Complete English Grammar Rules: Examples, Exceptions, Exercises, and Everything You Need to Master",
      author: "Peter Herring",
      url: "/pdf/english/english_grammar_mastery.pdf",
    },
    {
      title:
        "ENGLISH GRAMMAR MASTER IN 30 DAYS A step by step guide for a strong English foundation.",
      url: "/pdf/english/EnglishGrammarMasterin30Days.pdf",
      author: "Xyli C. Gonzales",
    },
    {
      title:
        "English Made Easy Volume One: A New ESL Approach: Learning English Through Pictures",
      author: "",
      url: "",
    },
    {
      title: "South Sudan Secondary English S1  ",
      url: "pdf/english/english_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary English S1 Teacher's Guide",
      url: "pdf/english/englishteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary English S2  ",
      url: "pdf/english/english_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary English S2 Teacher's Guide",
      url: "pdf/english/englishteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary English S3  ",
      url: "pdf/english/english_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary English S3 Teacher's Guide",
      url: "pdf/english/englishteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary English S4  ",
      url: "pdf/english/english_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary English S4 Teacher's Guide",
      url: "pdf/english/englishteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  addtionalMAths: [
    {
      title:
        "Complete Additional Mathematics for Cambridge IGCSE and O'level",
      author: "Ministry of Education",
      url: "/pdf/addtionalMAths/Complete Additional Mathematics for Cambridge IGCSE® & O Level ( PDFDrive ).pdf",
    },
    {
      title:
        "South Sudan Additional Mathematics 3 Teacher's Guide (third Year)",
      author: "Ministry of Education",
      url: "/pdf/addtionalMAths/Guide3.pdf",
    },
    {
      title: "Additional Mathematics Student’s Book 4 (fouth year)",
      author: "Ministrey of General Education",
      url: "/pdf/addtionalMAths/aditionalMathss4.pdf",
    },
    {
      title:
        "South Sudan Additional Mathematics  Teacher's Guide (fourth Year)",
      author: "Ministrey of General Education",
      url: "/pdf/addtionalMAths/guide4.pdf",
    },
  ],
  citizenships: [
    {
      title: "South Sudan Secondary Citizenship S1  ",
      url: "pdf/citizenship/citizenship_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Citizenship S1 Teacher's Guide",
      url: "pdf/citizenship/citizenshipteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Citizenship S2  ",
      url: "pdf/citizenship/citizenship_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Citizenship S2 Teacher's Guide",
      url: "pdf/citizenship/citizenshipteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Citizenship S3  ",
      url: "pdf/citizenship/citizenship_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Citizenship S3 Teacher's Guide",
      url: "pdf/citizenship/citizenshipteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Citizenship S4  ",
      url: "pdf/citizenship/citizenship_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Citizenship S4 Teacher's Guide",
      url: "pdf/citizenship/citizenshipteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  geography: [
    {
      title: "South Sudan Secondary Geography S1  ",
      url: "pdf/geography/geography_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Geography S1 Teacher's Guide",
      url: "pdf/geography/geographyteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Geography S2  ",
      url: "pdf/geography/geography_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Geography S2 Teacher's Guide",
      url: "pdf/geography/geographyteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Geography S3  ",
      url: "pdf/geography/geography_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Geography S3 Teacher's Guide",
      url: "pdf/geography/geographyteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Geography S4  ",
      url: "pdf/geography/geography_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Geography S4 Teacher's Guide",
      url: "pdf/geography/geographyteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  history: [
    {
      title: "South Sudan Secondary History S1  ",
      url: "pdf/history/history_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary History S1 Teacher's Guide",
      url: "pdf/history/historyteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary History S2  ",
      url: "pdf/history/history_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary History S2 Teacher's Guide",
      url: "pdf/history/historyteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary History S3  ",
      url: "pdf/history/history_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary History S3 Teacher's Guide",
      url: "pdf/history/historyteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary History S4  ",
      url: "pdf/history/history_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary History S4 Teacher's Guide",
      url: "pdf/history/historyteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  // ICT
  ict: [
    {
      title: "South Sudan Secondary I.C.T S1  ",
      url: "pdf/ICT/ICT_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary I.C.T S1 Teacher's Guide",
      url: "pdf/ICT/ICTteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary I.C.T S2  ",
      url: "pdf/ICT/ICT_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary I.C.T S2 Teacher's Guide",
      url: "pdf/ICT/ICTteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary I.C.T S3  ",
      url: "pdf/ICT/ICT_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary I.C.T S3 Teacher's Guide",
      url: "pdf/ICT/ICTteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary I.C.T S4  ",
      url: "pdf/ICT/ICT_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary I.C.T S4 Teacher's Guide",
      url: "pdf/ICT/ICTteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  // Kiswahili
  kiswahili: [
    {
      title: "South Sudan Secondary Kiswahili S1  ",
      url: "pdf/Kiswahili/Kiswahili_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Kiswahili S1 Teacher's Guide",
      url: "pdf/Kiswahili/Kiswahiliteacherquide_s1.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Kiswahili S2  ",
      url: "pdf/Kiswahili/Kiswahili_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Kiswahili S2 Teacher's Guide",
      url: "pdf/Kiswahili/Kiswahiliteacherquide_s2.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Kiswahili S3  ",
      url: "pdf/Kiswahili/Kiswahili_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Kiswahili S3 Teacher's Guide",
      url: "pdf/Kiswahili/Kiswahiliteacherquide_s3.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Kiswahili S4  ",
      url: "pdf/Kiswahili/Kiswahili_s4.pdf",
      author: "Ministry of General Education",
    },
    {
      title: "South Sudan Secondary Kiswahili S4 Teacher's Guide",
      url: "pdf/Kiswahili/Kiswahiliteacherquide_s4.pdf",
      author: "Ministry of General Education",
    },
  ],
  // primary school Books
  primarySchool: [
    {
      title: "South Sudan Primary School C.R.E P1 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/p1.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P1 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/teacherGuide1.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P2 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/p2.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P2 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/teacherGuide2.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P3 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/p3.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P3 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/teacherGuide3.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P4 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/p4.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P4 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/teacherGuide4.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P5 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/p5.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P5 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/teacherGuide5.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P6 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/p6.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P6 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/teacherGuide6.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P7 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/p7.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P7 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/teacherGuide7.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P8 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/p8.pdf",
    },
    {
      title: "South Sudan Primary School C.R.E P8 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/cre/teacherGuide8.pdf",
    },
    // english
    {
      title: "South Sudan Primary School English P1 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishP1.pdf",
    },
    {
      title: "South Sudan Primary School English P1 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishGuideP1.pdf",
    },
    {
      title: "South Sudan Primary School English P2 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishP2.pdf",
    },
    {
      title: "South Sudan Primary School English P2 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishGuideP2.pdf",
    },
    {
      title: "South Sudan Primary School English P3 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishP3.pdf",
    },
    {
      title: "South Sudan Primary School English P3 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishGuideP3.pdf",
    },
    {
      title: "South Sudan Primary School English P4 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishP4.pdf",
    },
    {
      title: "South Sudan Primary School English P4 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishGuideP4.pdf",
    },
    {
      title: "South Sudan Primary School English P5 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishP5.pdf",
    },
    {
      title: "South Sudan Primary School English P5 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishGuideP5.pdf",
    },
    {
      title: "South Sudan Primary School English P7 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishP7.pdf",
    },
    {
      title: "South Sudan Primary School English P7 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishGuideP7.pdf",
    },
    {
      title: "South Sudan Primary School English P8 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishP8.pdf",
    },
    {
      title: "South Sudan Primary School English P8 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/english/englishGuideP8.pdf",
    },
    // mathematics
    {
      title: "South Sudan Primary School Mathematics P8 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathematicsP8.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P8 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathsGuideP8.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P7 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathematicsP7.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P7 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/Primary Mathematics 7 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P6 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathematicsP6.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P6 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/Primary Mathematics 6 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P5 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathematicsP5.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P5 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/Primary Mathematics 5 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P4 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathematicsP4.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P4 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/Primary Mathematics 4 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P3 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathematicsP3.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P3 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/Primary Mathematics 3 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P2 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathematicsP2.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P2 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/Primary Mathematics 2 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P1 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/mathematicsP1.pdf",
    },
    {
      title: "South Sudan Primary School Mathematics P1 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/maths/Primary Mathematics 1 Teacher Guide.pdf",
    },
    // science books
    {
      title: "South Sudan Primary School Science P1 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 1 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School Science P1 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 1 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Science P2 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 2 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School Science P2 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 2 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Science P3 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 3 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School Science P3 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 3 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Science P4 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 4 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School Science P4 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 4 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Science P5 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 5 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School Science P5 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 5 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Science P6 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 6 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School Science P6 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 6 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Science P7 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 7 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School Science P7 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 7 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School Science P8 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 8 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School Science P8 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/science/Primary Science 8 Teacher Guide.pdf",
    },
    // SST
    {
      title: "South Sudan Primary School S.S.T P1 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 1 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P1 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 1 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P2 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 2 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P2 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 2 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P3 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 3 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P3 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 3 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P4 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 4 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P4 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 4 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P5 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 5 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P5 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 5 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P6 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 6 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P6 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 6 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P7 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 7 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P7 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 7 Teacher Guide.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P8 Textbook",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 8 PB Textbook.pdf",
    },
    {
      title: "South Sudan Primary School S.S.T P8 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 8 Teacher Guide.pdf",
    },
  ],
  // commerce
  commerce: [
    {
      title: "Cambridge O Level Commerce Provide full coverage of the latest syllabus for examination ",
      author: "DR ALAN WHITCOMB",
      url: "/pdf/commerce/Cambridge O Level Commerce (Alan Whitcomb).pdf",
    },
    // {
    //   title:"",author:"DR ALAN WHITCOMB", url:"/pdf/commerce/"
    // }
  ],
  // agriculture
  agriculture: [
    {
      title: "South Sudan Primary School S.S.T P8 Teacher's Guide",
      author: "Ministry of General Education",
      url: "/pdf/primaryschool/sst/SST Primary 8 Teacher Guide.pdf",
    },
  ],
};

export default books;
